<template>
  <div class="text-center" fill-height fluid>
    <v-dialog ref="dlg" v-model="dialog" width="750">
      <template v-slot:activator="{ on, attrs }"></template>

      <v-card class="pa-5 text-center rounded-lg">
        <div class="center" align="center" justify="center">
          <v-img
            style=" width : 300px"
            src="https://cdn.siap.id/s3/masook/asset%20img/SIM/info.png"
          ></v-img>
        </div>
        <p class="title mt-5">
          {{ title }}
        </p>
        <v-card-text class="pb-0" v-if="current_organisasi">
          <p class="text-center black--text mb-0" v-html="info"></p>
          <div class="text-center pt-4">
            <m-button
              class="a-2"
              text="Tutup"
              :large="false"
              color="primary"
              action="close"
              @close="dialog = false"
            ></m-button>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      dialog: false
    };
  },
  props: {
    title: {
      type: String,
      default: "Info"
    },
    info: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: "mdi-information"
    },
    color: {
      type: String,
      default: "primary"
    },
    isClose: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    // eslint-disable-next-line
    open(obj) {
      this.dialog = true;
    }
  }
};
</script>
